var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("input", {
      ref: "file",
      attrs: { type: "file", id: "uploadQuestion", name: "uploadQuestion" },
      on: {
        change: function ($event) {
          return _vm.handleFileUpload()
        },
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "loading_indicator_wrapper",
        staticClass: "loading-indicator-wrapper",
      },
      [
        _c("div", { ref: "loading_indicator", staticClass: "loading" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("span", { staticClass: "loading-message" }, [
            _vm._v("ページをリロードしないでください"),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "preloader" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }